import { without, append, contains, sortBy, prop, omit, isEmpty } from 'ramda'

import {
  ACTIVATE_WEB_TO_PRINT_MODE,
  END_WEB_TO_PRINT_MODE,
  TOGGLE_CONTENT_FOR_PRINT,
  MARK_CONTENT_LOADED
} from '../actions/webToPrint'

const initialState = {
  webToPrintModeActive: false,
  contentSelectedForPrint: {
    'customer-benefit': [],
    topic: [],
    component: []
  },
  loadingPrintContent: {},
  readyToPrint: false
}

const sortByIndex = sortBy(prop('index'))

export default function setContentFilter(state = initialState, action) {
  switch (action.type) {
    case ACTIVATE_WEB_TO_PRINT_MODE:
      return {
        ...state,
        webToPrintModeActive: true
      }
    case END_WEB_TO_PRINT_MODE:
      return initialState
    case TOGGLE_CONTENT_FOR_PRINT: {
      const { contentSelectedForPrint, loadingPrintContent } = state
      const { contentType, contentItem } = action
      const { slug: itemSlug } = contentItem

      const contentOfType = contentSelectedForPrint[contentType]

      const isContentAlreadySelected = contains(contentItem, contentOfType)

      const updatedContentOfType = isContentAlreadySelected
        ? without([contentItem], contentOfType)
        : append(contentItem, contentOfType)

      const updatedContentSelectedForPrint = {
        ...contentSelectedForPrint,
        [contentType]: sortByIndex(updatedContentOfType)
      }

      const topicSlugName = `${contentType}_${itemSlug}`

      const updatedLoadingPrintContent = isContentAlreadySelected
        ? omit([topicSlugName], loadingPrintContent)
        : {
            ...loadingPrintContent,
            [topicSlugName]: true
          }

      return {
        ...state,
        contentSelectedForPrint: updatedContentSelectedForPrint,
        loadingPrintContent: updatedLoadingPrintContent,
        readyToPrint: isEmpty(updatedLoadingPrintContent)
      }
    }
    case MARK_CONTENT_LOADED: {
      const { loadingPrintContent } = state
      const { contentType, itemSlug } = action

      const topicSlugName = `${contentType}_${itemSlug}`

      const updatedLoadingPrintContent = omit(
        [topicSlugName],
        loadingPrintContent
      )

      return {
        ...state,
        loadingPrintContent: updatedLoadingPrintContent,
        readyToPrint: isEmpty(updatedLoadingPrintContent)
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/webToPrint.js